"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formFieldState = void 0;
var lodash_1 = require("lodash");
var formFieldState = function (fields) {
  return (0, lodash_1.mapValues)((0, lodash_1.keyBy)(fields, 'name'), function (_a) {
    var valid = _a.valid,
      validate = _a.validate,
      focus = _a.focus,
      value = _a.value,
      defaultValue = _a.defaultValue;
    return {
      valid: valid,
      validate: validate,
      focus: focus,
      defaultValue: defaultValue,
      value: value
    };
  });
};
exports.formFieldState = formFieldState;